import { customElement, property } from 'lit/decorators.js';
import { t } from 'src/i18n';
import { BaseDialog } from 'src/library/components/BaseDialog.js';
import { html } from 'lit';
import '../elements/d-edit-text.js';
import '../../elements/d-section.js';
import type { NewNameResult } from './new-name-result';
import type { NewNameInput } from './new-name-input';
import type { DialogActionInput } from 'src/library/components/DialogActionInput';

@customElement('new-name-dialog')
export class NewNameDialog extends BaseDialog<NewNameInput, NewNameResult> {
  @property({ type: String })
  newItemName = '';
  width = 400;

  protected get calculatedFooterActions(): DialogActionInput[] {
    return [
      { name: t('common:cancel'), action: 'cancel' },
      { name: t('newNameDialog.done'), action: 'done', main: true, disabled: !this.newItemName },
    ];
  }

  protected fetchResult(detail?: string): NewNameResult {
    return {
      name: detail === 'done' ? this.newItemName : '',
      action: detail === 'done' ? 'done' : 'cancel',
    };
  }

  protected initializeDialog(input: NewNameInput) {
    this.title = input.title;
  }

  protected renderBody() {
    return html`<d-section>
      <d-edit-text
        label=${t('newNameDialog.nameLabel')}
        .value=${this.newItemName}
        @value-changed=${this.onNewItemNameChanged}
      ></d-edit-text>
    </d-section>`;
  }

  private onNewItemNameChanged(e: CustomEvent<{ value: string }>) {
    this.newItemName = e.detail.value;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'new-name-dialog': NewNameDialog;
  }
}
